module.exports = __webpack_public_path__ + "img/purple-2-diamond-solid.61de7f38.svg";